import { initializeApp } from "firebase/app";

const initFirebase = (): void => {
  const firebaseConfig = {
    apiKey: "AIzaSyB2Unu6M1GRU1YVlvghzEHC-9-RJZUCpD0",
    authDomain: "netapp-cupid-game.firebaseapp.com",
    projectId: "netapp-cupid-game",
    storageBucket: "netapp-cupid-game.appspot.com",
    messagingSenderId: "547323700259",
    appId: "1:547323700259:web:6ada14f13170bb1dfa3d96",
    measurementId: "G-CRPX9HM81Q"
  };

  // Initialize Firebase
  initializeApp(firebaseConfig);
}

export default initFirebase;
